var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"welcome-nav"},[_c('div',{staticClass:"left"},[_c('h2',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t(_vm.welcome_top_title)))])]),_c('div',{staticClass:"right"})])}
var staticRenderFns = []

export { render, staticRenderFns }